var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2602_74447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.5 72H13.5C6.0435 72 0 65.9565 0 58.5V13.5C0 6.0435 6.0435 0 13.5 0H58.5C65.9565 0 72 6.0435 72 13.5V58.5C72 65.9565 65.9565 72 58.5 72Z",
    fill: "#F5E6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5072 26.0575C53.0077 25.4657 52.2765 25.126 51.5025 25.126H29.7157C28.431 25.126 27.342 26.0462 27.1282 27.313L24.7162 41.5622C24.5857 42.325 24.7995 43.1035 25.299 43.693C25.7985 44.2847 26.5297 44.6245 27.3037 44.6245H49.0905C50.3752 44.6245 51.4642 43.7042 51.678 42.4375L54.09 28.1882C54.2205 27.4255 54.0067 26.647 53.5072 26.0575ZM50.2897 31.9502L40.7655 35.8945C40.3605 36.0745 39.9105 36.1487 39.4762 36.1487C38.9655 36.1487 38.457 36.043 37.9912 35.8045L29.3355 31.5452L29.7247 29.2345L38.979 33.7952C39.2647 33.9302 39.609 33.946 39.9082 33.8245L50.724 29.3402L50.2897 31.9502ZM53.6062 30.301L53.7255 29.5517C53.7862 29.8195 53.7412 30.076 53.6062 30.301Z",
    fill: "#BE63F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0252 29.6255H19.5252C18.6972 29.6255 18.0244 28.9528 18.0244 28.1248C18.0244 27.2968 18.6949 26.624 19.5252 26.624H24.0252C24.8532 26.624 25.5259 27.2968 25.5259 28.1248C25.5259 28.9528 24.8532 29.6255 24.0252 29.6255Z",
    fill: "#D9A4FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5244 35.6243H19.5252C18.6972 35.6243 18.0244 34.9515 18.0244 34.1235C18.0244 33.2955 18.6949 32.625 19.5252 32.625H22.5244C23.3524 32.625 24.0252 33.2977 24.0252 34.1257C24.0252 34.9537 23.3547 35.6243 22.5244 35.6243Z",
    fill: "#D9A4FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0259 41.6245H19.5252C18.6972 41.6245 18.0244 40.9518 18.0244 40.1238C18.0244 39.2958 18.6949 38.623 19.5252 38.623H21.0259C21.8539 38.623 22.5267 39.2958 22.5267 40.1238C22.5267 40.9518 21.8539 41.6245 21.0259 41.6245Z",
    fill: "#D9A4FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2602_74447"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.0d653ad95e61c03efb2abf9bfb4adf62.svg";
export { ForwardRef as ReactComponent };